import { computed, Directive, input } from '@angular/core';
import { mergeClasses } from '@wheere-front/shared-util';
import type { VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';
import { ButtonVariants, buttonVariants } from './button.directive'; // Import your existing variants

@Directive({
  selector: '[libSplitBtnContainer]',
  standalone: true,
  host: {
    '[class]': '_containerClass()',
  },
})
export class SplitBtnContainerDirective {
  readonly userClass = input<ClassValue>('');

  protected _containerClass = computed(() =>
    mergeClasses('inline-flex items-center divide-x divide-white/20', this.userClass())
  );
}

@Directive({
  selector: '[libSplitBtnMain]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
})
export class SplitBtnMainDirective {
  readonly userClass = input<ClassValue>('');
  readonly variant = input<VariantProps<typeof buttonVariants>['variant']>('default');
  readonly size = input<VariantProps<typeof buttonVariants>['size']>('default');

  protected _computedClass = computed(() =>
    mergeClasses(
      buttonVariants({ variant: this.variant(), size: this.size() }),
      'rounded-r-none border-r-0', // Strips right rounding/border to join with the toggle
      this.userClass()
    )
  );
}

@Directive({
  selector: '[libSplitBtnToggle]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
})
export class SplitBtnToggleDirective {
  readonly userClass = input<ClassValue>('');
  readonly variant = input<ButtonVariants['variant']>('default');
  readonly size = input<ButtonVariants['size']>('default');

  protected _computedClass = computed(() =>
    mergeClasses(
      buttonVariants({
        variant: this.variant(),
        size: this.size(),
      }),
      'rounded-l-none border-l-0 px-1 flex items-center justify-center', // reduced padding for xxs
      this.userClass()
    )
  );
}
